import React, { useState } from 'react';

const InviteCard = () => {
    const [isFlipped, setIsFlipped] = useState(false);

    const handleImageClick = () => {
        setIsFlipped(!isFlipped);
    };

    const handleVisitSite = () => {
        // Naviga al path principale del sito
        window.location.href = '/';
    };

    return (
        <div className="invite-card-section">
            <div className="invite-card-wrapper">
                <div className={`invite-flip-container ${isFlipped ? 'flipped' : ''}`} onClick={handleImageClick}>
                    {/* Front side */}
                    <div className="invite-flip-front">
                        <img 
                            src="/assets/img/invite-page1.jpg" 
                            alt="Wedding Invitation" 
                            className="invite-image"
                        />
                    </div>
                    
                    {/* Back side */}
                    <div className="invite-flip-back">
                        <img 
                            src="/assets/img/invite-page2.jpg" 
                            alt="Wedding Invitation - Page 2" 
                            className="invite-image"
                        />
                    </div>
                </div>
                
                {/* Suggerimenti fuori dall'immagine */}
                {!isFlipped ? (
                    <div className="click-hint">
                        <span className="hint-icon">✨</span>
                        <span className="hint-text uppercase">Tocca la foto per scoprire</span>
                    </div>
                ) : (
                    // Container per elementi affiancati
                    <div className="back-hint-container">
                        <div className="back-hint">
                            <span className="hint-text uppercase">Tocca la foto per tornare</span>
                        </div>
                        <button className="visit-site-button" onClick={handleVisitSite}>
                            <span className="button-text uppercase">Visita il Qr Code</span>
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default InviteCard; 